import { API_URL } from "../util/url";
import fetchWithAuth from "../util/fetchWithAuth";

const requestWithAuth = async ({ url, method = "GET", data, headers }) => {
  const response = await fetchWithAuth(`${API_URL}${url}`, {
    method,
    headers,
    body: data,
  });

  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || "Помилка запиту");
  }

  const text = await response.text();
  if (!text) return null;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return JSON.parse(text);
  }
  return text;
};

const requestWithAuthAllowNotFound = async ({
  url,
  method = "GET",
  data,
  headers,
}) => {
  const response = await fetchWithAuth(`${API_URL}${url}`, {
    method,
    headers,
    body: data,
  });

  if (response.status === 404) return null;
  if (!response.ok) {
    const message = await response.text();
    throw new Error(message || "Помилка запиту");
  }

  const text = await response.text();
  if (!text) return null;
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) {
    return JSON.parse(text);
  }
  return text;
};

export const getDraft = (templateId) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/draft/`,
    method: "GET",
  });

export const getTemplates = ({ kind, crmId, productId } = {}) => {
  const params = new URLSearchParams();
  if (kind) params.set("kind", kind);
  if (crmId !== undefined && crmId !== null && crmId !== "") {
    params.set("crm", String(crmId));
  }
  if (productId !== undefined && productId !== null && productId !== "") {
    params.set("product_id", String(productId));
  }
  const query = params.toString();
  return requestWithAuth({
    url: `/scripts/script-templates/${query ? `?${query}` : ""}`,
    method: "GET",
  });
};

export const cloneTemplate = (payload) =>
  requestWithAuth({
    url: "/scripts/script-templates/clone/",
    method: "POST",
    data: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });

export const getTemplateDraft = (templateId) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/draft/`,
    method: "GET",
  });

export const getTemplateDetail = (templateId) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/`,
    method: "GET",
  });

export const updateTemplateCrossProducts = (templateId, crossProducts) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/`,
    method: "PATCH",
    data: JSON.stringify({ cross_products: crossProducts }),
    headers: { "Content-Type": "application/json" },
  });

export const getTemplateCrossProducts = (templateId) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/cross-products/`,
    method: "GET",
  });

export const updateTemplateCrossProductsMeta = (templateId, items) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/cross-products/`,
    method: "PATCH",
    data: JSON.stringify(items),
    headers: { "Content-Type": "application/json" },
  });

export const saveStructure = (templateId, payload) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/save-structure/`,
    method: "POST",
    data: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });

export const saveTemplateStructure = (templateId, payload) =>
  requestWithAuth({
    url: `/scripts/script-templates/${templateId}/save-structure/`,
    method: "POST",
    data: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });

export const publishVersion = (versionId) =>
  requestWithAuth({
    url: `/scripts/script-versions/${versionId}/publish/`,
    method: "POST",
  });

export const resolveScriptTemplate = ({ kind, crmId, productId }) =>
  requestWithAuth({
    url: `/scripts/script-templates/resolve/?kind=${encodeURIComponent(
      kind
    )}&crm=${encodeURIComponent(crmId)}&product_id=${encodeURIComponent(
      productId
    )}`,
    method: "GET",
  });

export const getScriptTemplateOverride = ({ kind, crmId, productId }) =>
  requestWithAuthAllowNotFound({
    url: `/scripts/script-templates/override/?kind=${encodeURIComponent(
      kind
    )}&crm=${encodeURIComponent(crmId)}&product_id=${encodeURIComponent(
      productId
    )}`,
    method: "GET",
  });

const buildOverrideQuery = (payload) => {
  const kind = payload?.kind;
  const crm = payload?.crm;
  const productId = payload?.product_id;
  if (!kind || crm === undefined || crm === null || productId === undefined || productId === null) {
    return "";
  }
  return `?kind=${encodeURIComponent(kind)}&crm=${encodeURIComponent(
    crm
  )}&product_id=${encodeURIComponent(productId)}`;
};

export const saveScriptTemplateOverride = (payload, overrideId, overrideQuery) =>
  requestWithAuth({
    url: `/scripts/script-templates/override/${
      overrideId ? overrideQuery || buildOverrideQuery(payload) : ""
    }`,
    method: overrideId ? "PATCH" : "POST",
    data: JSON.stringify(payload),
    headers: { "Content-Type": "application/json" },
  });

export const deleteScriptTemplateOverride = ({ kind, crmId, productId }) =>
  requestWithAuth({
    url: `/scripts/script-templates/override/?kind=${encodeURIComponent(
      kind
    )}&crm=${encodeURIComponent(crmId)}&product_id=${encodeURIComponent(
      productId
    )}`,
    method: "DELETE",
  });
